// Sections Module Types

export enum SectionStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

/** Cuenta bancaria propia de una sección (mismos nombres que la API). */
export interface SectionBankInfo {
  bankName: string;
  accountHolder: string;
  clabe: string;
  accountNumber?: string;
  swift?: string;
  currency?: string;
  paymentInstructions?: string;
}

export interface Section {
  id: string;
  name: string;
  code: string;
  description?: string | null;
  status: SectionStatus;
  /** Cuota de mantenimiento de la sección; `null` = usa la cuota general. */
  maintenanceFee?: number | null;
  /** Cuenta bancaria propia; `null` = usa la del residencial. */
  bankInfo?: SectionBankInfo | null;
  /**
   * Métricas del catálogo. Solo las puebla `GET /sections`; en las respuestas
   * de una sola sección llegan en 0 y el detalle usa `/sections/:id/stats`.
   */
  unitsCount: number;
  residentsCount: number;
  /**
   * Miembros asignados vía `member_sections`: el administrador y los guardias
   * o staff acotados. No distingue unos de otros, así que solo sirve para
   * saber si hace falta pedir el detalle de administradores.
   */
  assignedMembersCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreateSectionDTO {
  name: string;
  code: string;
  description?: string;
  status?: SectionStatus;
  maintenanceFee?: number | null;
  bankInfo?: SectionBankInfo | null;
}

export interface UpdateSectionDTO {
  name?: string;
  code?: string;
  description?: string;
  maintenanceFee?: number | null;
  bankInfo?: SectionBankInfo | null;
}

export interface SectionStats {
  units: number;
  residents: number;
}

/** Métricas de nivel tenant, no de una sección (`GET /sections/stats`). */
export interface SectionTenantStats {
  /**
   * Unidades sin sección. Si es > 0 la migración está a medias: sus residentes
   * no ven el contenido de ninguna sección.
   */
  unassignedUnitsCount: number;
}

export interface SectionAdmin {
  memberId: string;
  masterUserId: string;
  name: string | null;
  email: string | null;
}